module.exports = __webpack_public_path__ + "0fdefae88aaed5d7f18948b45cf3086d.svg";